import { RMApiRequestEnum } from "@/constants";
import { MetricLocalization } from "@/types";
import { baseQuery, RestApiService, onQueryStarted } from "@develos/next-library";
import { createApi } from "@reduxjs/toolkit/query/react";

export const metricLocalizationsApi = createApi({
    baseQuery: baseQuery(RestApiService.ProjectApi),
    reducerPath: 'metricLocalizationsApi',
    endpoints: build => ({
        getMetricLocalizations: build.query<MetricLocalization[], void>({
            query: () => ({
                url: 'Metrics/GetMetricLocalizations',
                method: "GET"
            }), 
            onQueryStarted: onQueryStarted(RMApiRequestEnum.getMetricLocalizations)
        })
    })
});

export const {
    useGetMetricLocalizationsQuery
} = metricLocalizationsApi;